import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import {
  TouchableOpacity,
  Text,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
// import AORTypes from '../../types';
import App from '../../modules/data/App';
import GetApp from '../../q/GetApp';
import AppBadge from './AppBadge';

class AppBadgeById extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }

  render() {
    const { app, style, history } = this.props;

    if (!app) {
      return (<Text>Not found.</Text>);
      // return (<></>); // eslint-disable-line react/jsx-no-useless-fragment
    }

    return (
      <TouchableOpacity
        accessibilityLabel={app.data.name}
        accessibilityRole="link"
        href={`/ai-agent/${app.data.uuid}`}
        style={style}
        key={app.data.uuid}
        onPress={() => (
          history.push(`/ai-agent/${app.data.uuid}`)
        )}
      >
        <AppBadge
          data={app.data}
        />
      </TouchableOpacity>
    );
  }
}

AppBadgeById.defaultProps = {
  // TODO(clairbee): Even though 'app' is always supplied, we need a temporary value before graphql finishes loading
  app: null,
  style: {},
};

AppBadgeById.propTypes = {
  uuid: PropTypes.string.isRequired,
  app: PropTypes.instanceOf(App),
  style: ViewPropTypes.style,
  history: ReactRouterPropTypes.history.isRequired,
};

export default compose(
  graphql(GetApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }

      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.uuid,
      },
      client: AppSyncClientUnauthenticated,
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only',
    }),
    // client: AppSyncClientUnauthenticated,
  })
)(AppBadgeById);
